<template>

    <div>
            <table class="t1">
                <colgroup>
                    <col width="124">
                    <col width="124">
                    <col width="62">
                    <col width="62">
                    <col width="124">
                    <col width="124">
                    <col width="62">
                    <col width="62">
                    <col width="124">
                    <col width="124">
                    <col width="124">
                </colgroup>
                <tbody>
                <tr>
                    <td colspan="11" style="font-size: 21px;font-weight: bold;font-family: 宋体;"></td>
                </tr>
                <tr>
                    <td colspan="11" style="font-size: 21px;font-weight: bold;font-family: 宋体;">听课记录表</td>
                </tr>
                <tr>
                    <td colspan="11">{{ tkGgQueData.xnxqmc }}</td>
                </tr>
                <tr class="r1">
                    <td class="c1" style="height: 40px">授课教师</td>
                    <td class="c1" colspan="2">{{tkGgQueData.jsxm}}</td>
                    <td class="c1" colspan="2">教师所在系部</td>
                    <td class="c1" colspan="2">{{tkGgQueData.jsxbmc}}</td>
                    <td class="c1" colspan="2">听课日期</td>
                    <td class="c1" colspan="2">{{tkGgQueData.tkrq}}</td>
                </tr>
                <tr class="r1">
                    <td class="c2" style="height: 40px">授课班级</td>
                    <td class="c2" colspan="2">{{ tkGgQueData.tkbjmc }}</td>
                    <td class="c2" colspan="2">授课地点</td>
                    <td class="c2" colspan="2">{{tkGgQueData.jsmc}}</td>
                    <td class="c2" colspan="2">听课节次</td>
                    <td class="c2" colspan="2">{{tkGgQueData.tkjc}}</td>
                </tr>
                <tr class="r1">
                    <td class="c2" style="height: 40px">课程名称</td>
                    <td class="c2" colspan="4">{{tkGgQueData.kcmc}}</td>
                    <td class="c2" colspan="2">课题</td>
                    <td class="c2" colspan="4">{{tkGgQueData.kt}}</td>
                </tr>
                <tr class="r1">
                    <td class="c2" rowspan="4">到课情况</td>
                    <td class="c2" colspan="4" style="height: 40px">教师情况</td>
                    <td class="c2" colspan="6">学生情况</td>
                </tr>

                <tr class="r1">
                    <td class="c2" rowspan="2">按时上课<br>（&radic;）</td>
                    <td class="c3" colspan="2">迟到<br>（分钟）</td>
                    <td class="c1" rowspan="2">提前下课<br>（分钟）</td>
                    <td class="c1" rowspan="2">应到<br>人数</td>
                    <td class="c1" colspan="2" rowspan="2">实到<br>人数</td>
                    <td class="c1" rowspan="2">迟到<br>人数</td>
                    <td class="c4">迟到最长<br>（分钟）</td>
                    <td class="c4">早退<br>人数</td>
                </tr>
                <tr class="r1" style="height: 0">
                    <td class="c5" colspan="2"></td>
                    <td class="c2"></td>
                    <td class="c2"></td>
                </tr>
                <tr class="r1">
                    <td class="c2" style="height: 40px">{{tkGgQueData.sfassk}}</td>
                    <td class="c2" colspan="2">{{tkGgQueData.skcdsj}}</td>
                    <td class="c2">{{tkGgQueData.tqxksj}}</td>
                    <td class="c2">{{ tkGgQueData.ydxss }}</td>
                    <td class="c2" colspan="2">{{tkGgQueData.sdxss}}</td>
                    <td class="c2">{{tkGgQueData.cdxss}}</td>
                    <td class="c2">{{tkGgQueData.cdzcsj}}</td>
                    <td class="c2">{{tkGgQueData.ztxss}}</td>
                </tr>
                <tr class="r2">
                    <td class="c6" colspan="11" style="height: 40px">授课过程记录</td>
                </tr>
                <tr class="r1">
                    <td class="c10" colspan="11" style="height: 300px;vertical-align: top;">{{tkGgQueData.jxnrgc}}</td>
                </tr>
                <tr class="r1">
                    <td class="c8" colspan="11" style="height: 40px">教学建议</td>
                </tr>
                <tr class="r1">
                    <td class="c10" colspan="11" style="height: 300px;text-align: left;vertical-align: top;">{{tkGgQueData.zhpjjy}}</td>
                </tr>
                <tr class="r1">
                    <td class="c7" colspan="11" style="height: 40px">评价等级（勾选）：<span style="padding-left: 10px">{{tkGgQueData.pjdj}}</span></td>
                </tr>
                <tr class="r1">
                    <td class="c9"></td>
                </tr>
                </tbody>
            </table>

        <table class="t1">
            <colgroup>
                <col width="70">
                <col width="1046">
            </colgroup>
            <tbody>
            <tr class="r1">
                <td class="c1" colspan="2" style="font-weight: bold;font-family: 宋体;">公共基础课程参考指标</td>
            </tr>
            <tr class="r1">
                <td class="c1">目标<br>与<br>学情</td>
                <td class="c11">1.符合新时代对技术技能人才培养新要求，落实教育部颁布的公共基础课程教学标准有关要求，紧扣学校专业人才培养方案和课程教学安排，夯实学生科学文化基础，着力培养学生人文素养、职业素养、信息素养，培养学生工匠精神、科学精神、创新精神和终身学习能力。<br>2.教学目标表述明确、相互关联，重点突出、可评可测。<br>3.客观分析学生知识基础、认知能力、学习特点、专业特性等，详实反映学生整体情况与个体差异，准确预判教学难点。</td>
            </tr>
            <tr class="r1">
                <td class="c1">内容<br>与<br>策略</td>
                <td class="c11">1.思政课程按照“八个相统一”要求扎实推进创优建设；其他课程注重落实课程思政要求，结合课程特点挖掘思政元素，有机融入课程教学，达到润物无声的育人效果。<br>2.教学内容落实公共基础课程课标，突出思想性、科学性、基础性、职业性和时代性，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位。<br>3.教材选用、使用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源；教案完整、规范、简明、真实。<br>4.教学设计科学合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效。</td>
            </tr>
            <tr class="r1">
                <td class="c1">实施<br>与<br>成效</td>
                <td class="c11">1.教育思想和教学理念先进，遵循学生认知规律，反映日常教学实际。<br>2.按照授课计划实施教学，关注重点、难点的解决，能够针对学习反馈及时调整教学，突出学生中心，实行因材施教。<br>3.教学环境真实，满足教学需要，教学活动开展有序，教学互动深入有效，教学气氛生动活泼，学生学有所得。<br>4.关注教与学行为数据采集，针对目标要求开展考核与评价。<br>5.创新教学方式方法，合理运用前沿信息技术、数字化教学资源、设施设备改造传统教学，提升学习效果、提高教学与管理成效。</td>
            </tr>
            <tr class="r1">
                <td class="c1">教学<br>素养</td>
                <td class="c11">1.展现新时代职业院校教师良好的师德师风、教学能力和信息素养。<br>2.教师课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。<br>3.教学研究深入，学术功底扎实。</td>
            </tr>
            <tr class="r1">
                <td class="c1">特色<br>创新</td>
                <td class="c11">1.在落实立德树人、文化素养提升、课程思政建设等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验。<br>2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。<br>3.具有较大借鉴和推广价值。</td>
            </tr>
            </tbody>
        </table>


    </div>
</template>

<script>
export default {
    props: ['tkGgQueData'],
};
</script>
<style>
.b1 {
    white-space-collapsing: preserve;
}

.t1 {
    margin: auto;
    border-collapse: collapse;
    border-spacing: 0;
}

.r1 {
    height: 15.75pt;
}

.r2 {
    height: 14.25pt;
}

.r3 {
    height: 15.0pt;
}

.c1 {
    white-space: pre-wrap;
    text-align: center;
    border-top: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c2 {
    white-space: pre-wrap;
    text-align: center;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c3 {
    white-space: pre-wrap;
    text-align: center;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c4 {
    white-space: pre-wrap;
    text-align: center;
    border-top: thin solid black;
    border-right: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c5 {
    white-space: pre-wrap;
    text-align: center;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c6 {
    white-space: pre-wrap;
    background-color: white;
    border-left: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    font-weight: bold;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c7 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c8 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    font-weight: bold;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c9 {
    white-space: pre-wrap;
    text-align: center;
    color: black;
    font-size: 16px;
}

.c10 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
    text-align: left;
}

.c11 {
    white-space: pre-wrap;
    text-align: left;
    border-top: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
    padding-top: 20px;
    padding-bottom: 20px;

}
</style>



// WEBPACK FOOTER //
// queryTkGgEvaluate.vue?7624390c